var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2834 25.9663C14.9668 25.9663 14.6501 25.8496 14.4001 25.5996C13.9168 25.1163 13.9168 24.3163 14.4001 23.8329L23.8334 14.3996C24.3168 13.9163 25.1168 13.9163 25.6001 14.3996C26.0834 14.8829 26.0834 15.6829 25.6001 16.1663L16.1668 25.5996C15.9334 25.8496 15.6001 25.9663 15.2834 25.9663Z",
    fill: "#E40000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7168 25.9663C24.4001 25.9663 24.0834 25.8496 23.8334 25.5996L14.4001 16.1663C13.9168 15.6829 13.9168 14.8829 14.4001 14.3996C14.8834 13.9163 15.6834 13.9163 16.1668 14.3996L25.6001 23.8329C26.0834 24.3163 26.0834 25.1163 25.6001 25.5996C25.3501 25.8496 25.0334 25.9663 24.7168 25.9663Z",
    fill: "#E40000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 37.9163H14.9999C5.94992 37.9163 2.08325 34.0497 2.08325 24.9997V14.9997C2.08325 5.94967 5.94992 2.08301 14.9999 2.08301H24.9999C34.0499 2.08301 37.9166 5.94967 37.9166 14.9997V24.9997C37.9166 34.0497 34.0499 37.9163 24.9999 37.9163ZM14.9999 4.58301C7.31659 4.58301 4.58325 7.31634 4.58325 14.9997V24.9997C4.58325 32.683 7.31659 35.4163 14.9999 35.4163H24.9999C32.6833 35.4163 35.4166 32.683 35.4166 24.9997V14.9997C35.4166 7.31634 32.6833 4.58301 24.9999 4.58301H14.9999Z",
    fill: "#E40000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.49fea9d6ee6b2fdb44b0512fecab8bac.svg";
export { ForwardRef as ReactComponent };